



























































































































































































































































































































import Vue, {AsyncComponent, ComponentOptions} from 'vue';
import Component from 'vue-class-component';
import BindAttrs from '@/utils/binds-attrs';
import '@/compiled-icons/funnel';
import '@/compiled-icons/funnel-outline';
import {COLOR_SERVICE_INSTANCE} from '@/services/style/color.service';
import {Prop} from 'vue-property-decorator';
import {DataTableItemProps} from 'vuetify';
import {FONT_SERVICE_INSTANCE} from '@/services/style/font.service';
import {
  AdvancedFieldFunctionConfiguration
} from '@/fields/advanced-field-function-executor/advanced-field-function-configuration';
import {ExtendedDynamicComponentList} from '@/fields/advanced-field-function-executor/conditional-components.interface';
import {CompositeKeyType} from '@/interfaces/key.interface';
import {cloneDeep, merge, set} from 'lodash';
import {HTTP_SERVICE_INSTANCE} from '@/services/http.service';
import {DisguiseBusinessExceptionWrapper} from '@/exception/disguise-business-exception-wrapper';
import {AMETRAS_PARAM_UTILS} from '@/utils/params.utils';
import {URL_SERVICE_INSTANCE} from '@/services/url.service';
import {HTML_SERVICE_INSTANCE} from '@/services/html.service';
import AlertDialog from '@/views/AlertDialog.vue';
import PromtDialog from '@/views/PromtDialog.vue';
import {
  DATATABLE_ROW_ACTION_CONFIGURATION_HANDLER_SERVICE_INSTANCE
} from '@/views/datatable/datatable-row-action-configuration-handler.service';
import {BehaviorSubject, Subject} from 'rxjs';
import {SUBJECT_UTILS_INSTANCE} from '@/utils/subject.utils';
import {ICONS_SERVICE_INSTANCE, IconsService} from '@/utils/icons.service';
import {DYNAMIC_FIELD_RESOLVER_INSTANCE} from '@/fields/dynamic-field-resolver';
import {FIELD_EVENTS_INSTANCE} from '@/fields/field-events';
// import {AUTOFILL_SERVICE_INSTANCE, AutofillFieldConfig} from '@/services/autofill.service';
import AmetrasAdvancedButtonTemplate from '@/fields/button/AmetrasAdvancedButtonTemplate.vue';
import {CustomDTIconUrlRowDto, CustomDTTemplateDto, ExtendedCell} from '@/views/datatable/datatable';
import AdvancedConfirmDialog, {
  ConfirmationDialogButton,
  ConfirmationDialogConfig
} from '@/views/AdvancedConfirmDialog.vue';
import {AmetrasAdvancedButtonState} from '@/fields/advanced-field-function-executor/button-state-executor';
import {
  AmetrasDisabledReasons,
  AmetrasHiddenReasons
} from '@/fields/advanced-field-function-executor/field-state-executor';
import {AxiosResponse} from 'axios';

type Component = ComponentOptions<Vue> | typeof Vue | AsyncComponent;

@Component({
  components: {
    AdvancedConfirmDialog,
    AmetrasAdvancedButtonTemplate,
    AlertDialog,
    PromtDialog
  },
  mixins: [BindAttrs]
})
export default class DatatableResultRow extends Vue {

  @Prop({required: true}) vuetifyRowItem!: DataTableItemProps;
  @Prop({required: true, default: 0}) firstNonHiddenColIdx!: boolean;
  @Prop({required: false, default: false}) tableIsLoading!: boolean;
  @Prop({required: false, default: false}) selectMode!: boolean;
  @Prop({required: false, default: false}) hasRowActions!: boolean;
  @Prop({required: false, default: false}) hasFloatingRowActions!: boolean;
  @Prop({required: false, default: false}) rowDragEnabled!: boolean;
  @Prop({required: false, default: false}) rowDragDisabled!: boolean;
  @Prop({required: true}) conditionalComponents!: ExtendedDynamicComponentList;
  @Prop({required: true}) input!: CustomDTTemplateDto; // todo: put only relevant things here
  @Prop({
    type: Object as () => CompositeKeyType,
    required: false,
    default: () => {
      return {};
    }
  }) contextParameter!: CompositeKeyType;

  rowConfiguration: {
    rowIcons?: CustomDTIconUrlRowDto[];
    cells?: ExtendedCell[];
  } = {
    cells: [],
  };

  buttonStates: {
    [uniqueButtonId: string]: AmetrasAdvancedButtonState
  } = {};

  canClickSave: boolean = true;

  colorService = COLOR_SERVICE_INSTANCE;
  iconsService: IconsService = ICONS_SERVICE_INSTANCE;
  fontService = FONT_SERVICE_INSTANCE;
  affeConf: AdvancedFieldFunctionConfiguration | undefined;
  columnIndexMap: { [key: string]: DisguiseDto.DTColumnsDto } = {};

  confirmationDialogConfig: ConfirmationDialogConfig | null = null;

  $refs!: {
    row: any,
    alert: AlertDialog,
    promt: PromtDialog
  };

  private pendingAFFERequestCount: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  /**
   * The text comes from the server because only there is it known what the order means
   * functionally and how far it reaches.
   */
  get rowDragHandleTitle(): string {
    return this.input.rowDragAndDrop?.dragHandleTooltip || '';
  }

  getBackgroundStyleFromPriorityList(
      backgroundColorPriority: DisguiseDto.EnumColor[]
  ) {
    let result = '';
    for (const currentBackgroundColorEntry of backgroundColorPriority || []) {
      if (currentBackgroundColorEntry) {
        result = this.colorService.getColor(
            currentBackgroundColorEntry,
            'BACKGROUND',
            this.$vuetify.theme.dark,
            true
        );
        break;
      }
    }
    return result;
  }

  getFontStyleFromPriorityList(
      fontWeightPriority: DisguiseDto.EnumFontWeight[]
  ) {
    let result = '';

    for (const currentFontWeightEntry of fontWeightPriority || []) {
      if (currentFontWeightEntry) {
        result = this.fontService.getFontWeight(currentFontWeightEntry);
        break;
      }
    }
    return result;
  }

  rowClicked(rowItem: DataTableItemProps) {
    this.$emit('row-clicked', rowItem);
  }

  onFieldValueChanged() {
    this.canClickSave = true;
  }

  buildRestURL(urlparameters: DisguiseDto.DTUrlParameterDto[] | undefined,
               urlbase: string,
               overrideValues: boolean,
               icon: DisguiseDto.DisguiseIcon):
      string {
    let restURL = urlbase;
    const params: CompositeKeyType = this.getPrimaryKeyForRowItem(
        this.input.columns || [],
        urlparameters,
        overrideValues,
        icon
    );
    restURL += (restURL.indexOf('?') > 0 ? '&' : '?') + URL_SERVICE_INSTANCE.serialize(params);
    return restURL;
  }

  iconMouseOverAction(rowHoverEvent: Event,
                      el: HTMLElement,
                      rowIcon: DisguiseDto.DTIconUrlRowDto
  ) {
    this.$emit('row-icon-mouse-over', {
      event: rowHoverEvent,
      htmlEl: el,
      icon: rowIcon
    });
  }

  iconMouseLeaveAction(rowLeaveEvent: Event,
                       el: HTMLElement,
                       rowIcon: DisguiseDto.DTIconUrlRowDto
  ) {
    this.$emit('row-icon-mouse-leave', {
      event: rowLeaveEvent,
      htmlEl: el,
      icon: rowIcon
    });
  }

  rowEnterPressedAction(rowEnterPressedEvent: Event,
                        rowItem: DataTableItemProps
  ) {
    for (const icon of rowItem.item.rowIcons || []) {
      if (icon.icon === 'SAVE') {
        this.rowIconClickAction(icon, rowItem);
      }
    }
  }

  rowIconClickAction(rowIcon: DisguiseDto.DTIconUrlRowDto,
                     rowItem: DataTableItemProps,
                     rowClickEvent?: Event
  ) {
    this.$set(rowIcon, 'loading', true);
    if (rowIcon.icon === 'SAVE') {
      this.removeServerSidedErrorMessage();
      this.$nextTick(() => {
        // wait until AFFE created the necessary requests by waiting for next tick

        SUBJECT_UTILS_INSTANCE.delayUntilSubjectMatchesFilterConditionOnce(
            this.pendingAFFERequestCount,
            (currentCount) => currentCount === 0,
            () => {
              this.$nextTick(() => {
                const fieldsContainingErrors = this.$refs.row.querySelectorAll('.error--text');
                if (fieldsContainingErrors.length <= 0) {
                  this.canClickSave = true;
                  this.save(rowIcon);
                } else {
                  HTML_SERVICE_INSTANCE.focusFirstNode(fieldsContainingErrors[0]);
                  this.canClickSave = false;
                  this.$store.commit('showSnack', {
                    message: 'Bitte korrigieren Sie alle rot markierten Felder',
                    color: 'warn'
                  });
                  this.$set(rowIcon, 'loading', false);
                }
              });
            },
            () => {
              this.$set(rowIcon, 'loading', false);
              // any further error is already handled within the corresponsing request.
            }
        );

      });
    } else if (rowIcon.actionConfiguration && rowIcon.actionConfiguration['@type'] === 'DTSaveActionConfiguration') {
      this.save(rowIcon);
    } else {
      this.$emit('row-icon-clicked', {
        event: rowClickEvent,
        icon: rowIcon,
        item: rowItem
      });
    }

  }

  cellButtonClicked(key: string, button: DisguiseDto.DTCellIconDto, event: MouseEvent) {
    const fieldReference = this.lookupFieldReference(key);
    if (fieldReference === undefined) {
      throw new Error('Unknown field reference');
    }
    if (button.prepend) {
      fieldReference.$emit('click:prepend', event);
    } else if (button.prependOuter) {
      fieldReference.$emit('click:prepend-outer', event);
    } else if (button.append) {
      fieldReference.$emit('click:append', event);
    } else if (button.appendOuter) {
      fieldReference.$emit('click:append-outer', event);
    }
  }

  mounted() {
    if (this.vuetifyRowItem.item) {
      const clonedRow = cloneDeep(this.vuetifyRowItem.item);
      if (clonedRow) {
        this.rowConfiguration = {
          ...clonedRow,
          cells: ((cells: DisguiseDto.DTCellDto[]) => {
            const result: ExtendedCell[] = [];
            for (const currentCell of cells || []) {
              result.push({
                ...currentCell,
                cellState: {
                  value: currentCell.value,
                  localErrorReasons: {},
                  readonlyReasons: {},
                  requiredReasons: {},
                  loadingReasons: {},
                  affeStyle: {}
                },
                remoteErrorReasons: {},
                component: DYNAMIC_FIELD_RESOLVER_INSTANCE.resolveComponent(
                    ((this.input.columns || [])[
                        currentCell.cellIndex === undefined ? -1 : currentCell.cellIndex
                        ] || {}).uiType,
                    (((this.input.columns || [])[
                        currentCell.cellIndex === undefined ? -1 : currentCell.cellIndex
                        ] || {}).dataType)
                ),
                fieldEventSubject: new Subject<{ eventName: string; eventArgs: any }>()
              });
            }
            return result;
          })(clonedRow.cells)
        };

        this.buttonStates = ((advancedButtons: DisguiseDto.AdvancedButtonDto[]) => {
          const result: {
            [uniqueButtonId: string]: AmetrasAdvancedButtonState
          } = {};

          for (const currentAdvancedButton of advancedButtons) {

            const disabledReasons: AmetrasDisabledReasons = {};
            if (currentAdvancedButton.disabled === true) {
              disabledReasons[''] = true;
            }
            const hiddenReasons: AmetrasHiddenReasons = {};
            if (currentAdvancedButton.hidden === true) {
              hiddenReasons[''] = true;
            }

            result[currentAdvancedButton.id || ''] = {
              disabledReasons,
              hiddenReasons,
              href: currentAdvancedButton.href,
              text: currentAdvancedButton.text,
              icon: currentAdvancedButton.icon
            };
          }

          return result;
        })(clonedRow.advancedButtons || []);

        if (this.input.advancedFieldFunctionConfigurationForResultRows) {
          const originalAffeConf = this.input.advancedFieldFunctionConfigurationForResultRows;
          const initialInit = this.affeConf === undefined;
          this.affeConf = new AdvancedFieldFunctionConfiguration(
              originalAffeConf,
              this.conditionalComponents,
              this.changeContextParam,
              this.triggerConditionalComponentEvent,
              this.handleBusinessException,
              (count) => {
                this.pendingAFFERequestCount.next(count);
              }
          );
          // builds advanced field functions
          this.$nextTick(() => {
            if (this.affeConf) {
              // holds a O(1) fast accessible model map, contains
              // DTColumnDto.key as key and DTColumnDto as value
              if (this.input.columns) {
                for (const currentColumn of this.input.columns) {
                  this.columnIndexMap[currentColumn.key || ''] = currentColumn;
                }
              }
              for (const currentFieldFunction of originalAffeConf.advancedFieldFunctions || []) {
                // build new function executor
                const functionExecutor = this.affeConf.bindNewFieldFunctionExecutor(
                    currentFieldFunction
                );

                for (const currentFieldReferenceDescription
                    of currentFieldFunction.fieldReferenceDescriptions || []) {
                  if (currentFieldReferenceDescription['@type'] === 'DTFieldReferenceDescription') {
                    const castedCurrentFieldReferenceDescription =
                        currentFieldReferenceDescription as
                            DisguiseDto.DTFieldReferenceDescription;
                    if (castedCurrentFieldReferenceDescription.key) {
                      const fieldRef = this.lookupFieldReference(castedCurrentFieldReferenceDescription.key || '');
                      const modelIndex =
                          this.columnIndexMap[castedCurrentFieldReferenceDescription.key];
                      if (!modelIndex) {
                        throw new Error(
                            'Model value lookup for AdvancedFieldFunctionExecutor failed.'
                        );
                      }

                      if (modelIndex.columnIndex !== undefined && modelIndex.key !== undefined) {
                        const currentCell: ExtendedCell = (this.rowConfiguration?.cells || [])[modelIndex.columnIndex];
                        functionExecutor.bindNewFieldStateExecutor(
                            fieldRef,
                            currentFieldReferenceDescription,
                            currentCell.cellState,
                            currentCell.fieldEventSubject
                        );
                      } else {
                        throw new Error(
                            'Columnindex and ColumnKey must not be undefined.'
                        );
                      }
                    }
                  } else if (currentFieldReferenceDescription['@type'] === 'AdvancedButtonReferenceDescription') {
                    if (currentFieldReferenceDescription.id) {
                      const buttonRef = (this.$refs as any)[currentFieldReferenceDescription.id];
                      if (buttonRef) {
                        let finalButtonRef = buttonRef;
                        if (Array.isArray(finalButtonRef)) {
                          finalButtonRef = finalButtonRef[0];
                        }
                        functionExecutor.bindNewButtonStateExecutor(
                            finalButtonRef as Vue,
                            currentFieldReferenceDescription,
                            this.buttonStates[currentFieldReferenceDescription.id || ''],
                        );
                      } else {
                        throw new Error(
                            'Button lookup for AdvancedButtonReferenceDescription failed.'
                        );
                      }
                    } else {
                      throw new Error(
                          'Wrong field configuration.'
                      );
                    }
                  }
                }
                for (const currentContextReferenceDescription
                    of currentFieldFunction.contextFieldReferenceDescriptions || []) {
                  if (currentContextReferenceDescription.contextKeyPath) {
                    const contextParamValue =
                        this.contextParameter[currentContextReferenceDescription.contextKeyPath];
                    if (contextParamValue === undefined) {
                      throw new Error(
                          'context param value lookup for AdvancedFieldFunctionExecutor failed for keyPath: ' + currentContextReferenceDescription.contextKeyPath
                      );
                    }
                    functionExecutor.bindNewStaticContextField(
                        currentContextReferenceDescription,
                        contextParamValue
                    );
                  }
                }
              }
              this.affeConf.afterInit();
              if (!initialInit) {
                this.affeConf.afterReInit();
              }
            }
          });
        }
      }
    }
  }

  buildFieldEventListenerMap(
      fieldDefinition: ExtendedCell
  ): any {
    return FIELD_EVENTS_INSTANCE.buildPassthroughVueOnMapForAllEvents((eventName, eventArgs) => {
      if (eventName === 'change') {
        fieldDefinition.cellState.value = eventArgs;
      }
      fieldDefinition.fieldEventSubject.next({
        eventName,
        eventArgs
      });
    });
  }

  /**
   * Change propagation of context params
   */
  private changeContextParam(patchableContextParams: CompositeKeyType) {
    this.$emit('update-context-parameter', patchableContextParams);
  }

  /**
   * Change propagation of context params
   */
  private triggerConditionalComponentEvent(
      nativeActionConfiguration: DisguiseDto.INativeEventConfigurationUnion,
      eventData: any
  ) {
    this.$emit('trigger-conditional-component-event', {
      nativeActionConfiguration,
      eventData
    });
  }

  private handleBusinessException(errorResponse: AxiosResponse) {
    this.$emit('handle-business-exception', {errorResponse});
  }

  private lookupFieldReference(
      columnKey: string
  ): Vue {
    const fieldRefRaw = (this.$refs as any)[columnKey];
    let fieldRef = fieldRefRaw;
    if (Array.isArray(fieldRefRaw)) {
      // if the reference points to multiple els, take the first
      fieldRef = fieldRefRaw[0];
    }
    return fieldRef as Vue;
  }

  private removeServerSidedErrorMessage() {
    for (const currentCell of this.rowConfiguration.cells || []) {
      currentCell.remoteErrorReasons = {};
    }
  }

  private afterSuccessfullySaved() {
    this.writeCurrentValuesToAutocomplete();
    this.affeConf?.afterInit();
    this.affeConf?.afterReInit();
    this.$store.commit('showSnack', {
      message: 'Speichern erfolgreich',
      color: 'success'
    });
  }

  private setFocusToFirstError() {
    if (this.rowConfiguration.cells && this.input.columns) {
      for (let currentCellIdx = 0; currentCellIdx < this.rowConfiguration.cells.length; currentCellIdx++) {
        const currentCell = this.rowConfiguration.cells[currentCellIdx];
        const currentCellLocalErrors = currentCell.cellState.localErrorReasons;
        const currentCellRemoteErrors = currentCell.remoteErrorReasons;
        if (Object.values(currentCellLocalErrors).concat(Object.values(currentCellRemoteErrors)).length > 0) {
          const fieldReferenceDescription: DisguiseDto.DTFieldReferenceDescription = {
            ['@type']: 'DTFieldReferenceDescription',
            key: this.input.columns[currentCellIdx].key
          };

          const fieldRef = this.lookupFieldReference(fieldReferenceDescription.key || '');
          HTML_SERVICE_INSTANCE.focusFirstNode(fieldRef.$el);
          break;
        }
      }
    }
  }

  private save(action: CustomDTIconUrlRowDto,
               additionalUrlParams?: { [key: string]: string }
  ) {
    this.$nextTick(() => {
      // wait until AFFE created the necessary requests by waiting for next tick

      SUBJECT_UTILS_INSTANCE.delayUntilSubjectMatchesFilterConditionOnce(
          this.pendingAFFERequestCount,
          (currentCount) => currentCount === 0,
          () => {
            this.$nextTick(() => {
              this.$nextTick(() => {
                // wait until AFFE updated the data based on results by waiting for next tick

                if (!this.input.submitWithBody && action.icon) {
                  // save using query parameters
                  HTTP_SERVICE_INSTANCE.getAxios().put(this.buildRestURL(
                      action.urlParameters || [],
                      action.urlBase || '',
                      action.icon !== 'DELETE',
                      action.icon
                  )).then(() => {
                    this.writeCurrentValuesToAutocomplete();
                    this.$store.commit('showSnack', {
                      message: 'Speichern erfolgreich',
                      color: 'success'
                    });
                    DATATABLE_ROW_ACTION_CONFIGURATION_HANDLER_SERVICE_INSTANCE.triggerRowActionConfiguration(action.actionConfiguration);
                    this.$set(action, 'loading', false);
                  }, (error) => {
                    if (!(error instanceof DisguiseBusinessExceptionWrapper)) {
                      this.$store.commit('showSnack', {
                        message: 'Speichern fehlgeschlagen',
                        color: 'error'
                      });
                    }
                    this.$set(action, 'loading', false);
                  });
                } else {
                  let cellHasLocalErrors: boolean = false;

                  for (const currentCell of this.rowConfiguration.cells || []) {
                    cellHasLocalErrors = Object.values(currentCell.cellState.localErrorReasons).length > 0;
                    if (cellHasLocalErrors) {
                      break;
                    }
                  }

                  const actionUrlParams = {};
                  for (const currentActionParameter of action.urlParameters || []) {
                    set(actionUrlParams, currentActionParameter.parameter || '', currentActionParameter.value);
                  }
                  const actionUrlBase = action.urlBase || '';

                  let submitUrl: string;
                  const urlParams = URL_SERVICE_INSTANCE.serialize({
                    ...actionUrlParams,
                    ...(cellHasLocalErrors ? {hasClientErrors: cellHasLocalErrors} : {}),
                    ...(additionalUrlParams ? additionalUrlParams : {}),
                    ...(this.contextParameter ? this.contextParameter : {})
                  });
                  if (urlParams) {
                    submitUrl = actionUrlBase
                        + (actionUrlBase.indexOf('?') > -1 ? '&' : '?')
                        + urlParams;
                  } else {
                    submitUrl = actionUrlBase;
                  }

                  const params: CompositeKeyType = this.getPrimaryKeyForRowItem(
                      this.input.columns || [],
                      undefined,
                      false,
                      action.icon
                  );

                  let triggerActionConfig = false;

                  HTTP_SERVICE_INSTANCE.getAxios().put(submitUrl, params).then((response) => {
                    this.removeServerSidedErrorMessage();

                    if (response.data.dialogParameterDto) {
                      if (!response.data.dialogParameterDto.done) {
                        switch (response.data.dialogParameterDto.dialogType) {
                          case 'PROMT_DIALOG':
                            this.$refs.promt.open('Achtung',
                                response.data.dialogParameterDto.dialogMessage).then(
                                (input: string) => {
                                  const configuredId = response.data.dialogParameterDto.dialogConfirmedId;
                                  this.save(action, {
                                    ...(input ? {promtInput: input} : {}),
                                    ...(configuredId ? {dialogId: configuredId} : {dialogId: 0})
                                  });
                                });
                            break;
                          case 'ALERT_DIALOG':
                            (this.$refs.alert as any).open('Achtung',
                                [response.data.dialogParameterDto.dialogMessage]).then(() => {
                              const configuredId = response.data.dialogParameterDto.dialogConfirmedId;
                              this.save(action, {
                                ...(configuredId ? {dialogId: configuredId} : {dialogId: 0})
                              });
                            });
                            break;
                          case 'CONFIRM_DIALOG':
                            this.confirmationDialogConfig = {
                              title: 'Bestätigen',
                              headerColor: 'primary',
                              message: response.data.dialogParameterDto.dialogMessage || '',
                              closeButton: {
                                onClick: () => {
                                  this.$set(action, 'loading', false);
                                  this.confirmationDialogConfig = null;
                                }
                              },
                              buttons: [{
                                text: response.data.confirmButtonTitle || 'Bestätigen',
                                title: response.data.confirmButtonTitle || 'Bestätigen',
                                disabled: false,
                                loading: false,
                                autoFocus: true,
                                onClick: () => {
                                  const configuredId = response.data.dialogParameterDto.dialogConfirmedId;
                                  this.save(action, {
                                    ...(configuredId ? {dialogId: configuredId} : {dialogId: 0})
                                  });
                                  this.confirmationDialogConfig = null;
                                }
                              }, {
                                text: response.data.abortButtonTitle || 'Abbrechen',
                                title: response.data.abortButtonTitle || 'Abbrechen',
                                disabled: false,
                                loading: false,
                                onClick: () => {
                                  const configuredId = response.data.dialogParameterDto.dialogAbortId;
                                  this.save(action, {
                                    ...(configuredId ? {dialogId: configuredId} : {dialogId: 0})
                                  });
                                  this.confirmationDialogConfig = null;
                                }
                              }],
                              onEsc: () => {
                                this.$set(action, 'loading', false);
                                this.confirmationDialogConfig = null;
                              }
                            };
                            break;
                          default:
                            break;
                        }
                      } else {
                        triggerActionConfig = true;
                        this.$set(action, 'loading', false);
                      }

                      if (response.data.dialogParameterDto.reloadDataAfterSuccess) {
                        this.$emit('load-data');
                      }

                      if (response.data.dialogParameterDto.success) {
                        this.afterSuccessfullySaved();
                        triggerActionConfig = true;
                        this.$set(action, 'loading', false);
                      }

                    } else {
                      this.afterSuccessfullySaved();
                      triggerActionConfig = true;
                      this.$set(action, 'loading', false);
                    }
                    if (triggerActionConfig) {
                      if (action.actionConfiguration && action.actionConfiguration.events) {
                        for (const currentEvent of action.actionConfiguration.events) {
                          if (currentEvent.type === 'ReloadDTEventDto') {
                            this.$emit('load-data');
                          }
                        }
                      }

                      DATATABLE_ROW_ACTION_CONFIGURATION_HANDLER_SERVICE_INSTANCE.triggerRowActionConfiguration(action.actionConfiguration);
                    }
                  }, (error) => {
                    if (!(error instanceof DisguiseBusinessExceptionWrapper)) {
                      if (error.response.data && error.response.data['@type'] === 'DTValidationResultDto') {
                        this.removeServerSidedErrorMessage();
                        const castedResponse = error.response.data as DisguiseDto.DTValidationResultDto;
                        if (error.response.status === 400) {
                          if (castedResponse.validationEntries && this.rowConfiguration.cells) {
                            const combinedErrors = [];
                            for (const remoteErrorDescription of castedResponse.validationEntries) {
                              if (remoteErrorDescription.key) {
                                const index = this.columnIndexMap[remoteErrorDescription.key].columnIndex;
                                if (index && index >= 0) {
                                  const currentCell = this.rowConfiguration.cells[index];
                                  currentCell.remoteErrorReasons[remoteErrorDescription.validationMessage || ''] =
                                      remoteErrorDescription.validationMessage || '';

                                  if (remoteErrorDescription.newValue !== undefined) {
                                    currentCell.cellState.value = remoteErrorDescription.newValue;
                                  }

                                  const allErrors = Object.values(currentCell.cellState.localErrorReasons)
                                      .concat(Object.values(currentCell.remoteErrorReasons));

                                  for (error of allErrors) {
                                    combinedErrors.push(error);
                                  }
                                }
                              }
                            }
                            if (combinedErrors.length > 0) {
                              this.$refs.alert.open('Achtung', combinedErrors).then(() => {
                                this.$nextTick(() => {
                                  this.setFocusToFirstError();
                                });
                              });
                            }
                          }
                          this.$set(action, 'loading', false);
                        } else {
                          this.$store.commit('showSnack', {
                            message: 'Speichern fehlgeschlagen',
                            color: 'error'
                          });
                          this.$set(action, 'loading', false);
                        }
                      } else if (error.response.data['@type'] === 'DisguiseBusinessExceptionConfirmationDialogDto') {
                        const castedResponse = error.response.data as DisguiseDto.DisguiseBusinessExceptionConfirmationDialogDto;

                        const confirmDialogButtons: ConfirmationDialogButton[] = [];
                        if (castedResponse.confirmButtonText) {
                          confirmDialogButtons.push({
                            text: castedResponse.confirmButtonText || '',
                            title: castedResponse.confirmButtonTitle || '',
                            disabled: false,
                            loading: false,
                            autoFocus: true,
                            onClick: (button: ConfirmationDialogButton, event, formularInstance) => {
                              if (castedResponse.confirmButtonAction && castedResponse.confirmButtonAction['@type'] === 'ConfirmationDialogUrlAction') {
                                button.loading = true;
                                const confirmUrl = (castedResponse.confirmButtonAction as DisguiseDto.ConfirmationDialogUrlActionDto).url || '';
                                action.urlBase = confirmUrl;
                                this.save(action,
                                    (additionalUrlParams || {}));
                                this.confirmationDialogConfig = null;
                              } else {
                                this.confirmationDialogConfig = null;
                              }
                            }
                          });
                        }
                        if (castedResponse.abortButtonText) {
                          confirmDialogButtons.push({
                            text: castedResponse.abortButtonText || '',
                            title: castedResponse.abortButtonTitle || '',
                            disabled: false,
                            loading: false,
                            onClick: () => {
                              this.confirmationDialogConfig = null;
                              this.$set(action, 'loading', false);
                            }
                          });
                        }

                        this.confirmationDialogConfig = {
                          title: castedResponse.title || '',
                          headerColor: 'primary',
                          message: castedResponse.message || '',
                          formular: castedResponse.formular,
                          buttons: confirmDialogButtons,
                          onEsc: () => {
                            this.confirmationDialogConfig = null;
                            this.$set(action, 'loading', false);
                          }
                        };
                      } else {
                        this.$store.commit('showSnack', {
                          message: 'Speichern fehlgeschlagen',
                          color: 'error'
                        });
                        this.$set(action, 'loading', false);
                      }
                    }
                    this.$set(action, 'loading', false);
                  });
                }
              });
            });
          },
          () => {
            this.$set(action, 'loading', false);
            // any further error is already handled within the corresponding request.
          }
      );
    });
  }

  private getPrimaryKeyForRowItem(
      columns: DisguiseDto.DTColumnsDto[],
      params?: DisguiseDto.DTUrlParameterDto[],
      overrideValues?: boolean,
      icon?: DisguiseDto.DisguiseIcon): CompositeKeyType {
    let editKey: CompositeKeyType = {};
    if (params) {
      if (overrideValues) {
        const urlParamClone = [...params];
        for (const element of urlParamClone) {
          (columns || []).forEach((col) => {
            if (col.key === element.parameter && col.columnIndex !== undefined && this.rowConfiguration.cells) {
              element.value = this.rowConfiguration.cells[col.columnIndex].cellState.value;
              element.parameter = col.dtoPath ? col.dtoPath : (element.parameter || '');
            }
          });
        }
        editKey = AMETRAS_PARAM_UTILS.convertParamListToCompositeKey(urlParamClone);
      } else {
        editKey = AMETRAS_PARAM_UTILS.convertParamListToCompositeKey(params);
      }
    } else if (this.rowConfiguration.cells) {
      // stupid way: bind all cell values
      for (let i = 0; i < this.rowConfiguration.cells.length; i++) {
        const cell = this.rowConfiguration.cells[i];
        if (columns && columns[i]) {
          set(editKey, columns[i].dtoPath || columns[i].key || '', cell.cellState.value || '');
        }
      }
    }

    if (this.affeConf && icon) {
      const operationParameters = this.affeConf.getOperationParameters(icon);
      merge(editKey, operationParameters);
    }

    return editKey;
  }

  private writeCurrentValuesToAutocomplete() {
    /* // save current values manually to autocomplete
     const autofillFields: AutofillFieldConfig[] = [];
     for (let currentCellIdx = 0; currentCellIdx < ((this.rowConfiguration || {}).cells || []).length; currentCellIdx++) {
       const cell = ((this.rowConfiguration || {}).cells || [])[currentCellIdx];
       const currentColumn = (this.input.columns || [])[currentCellIdx];
       if (currentColumn.autofillName !== undefined && cell.cellState.value !== undefined) {
         autofillFields.push({
           autofillName: currentColumn.autofillName,
           value: cell.cellState.value
         });
       }
     }
     AUTOFILL_SERVICE_INSTANCE.saveAutofillValues(autofillFields);*/
  }
}
